export const APP_VERSION = "0.7";

export const DEFAULT_RESUME_CONTENT: string = 
`content:
  basics:
    name: Irshad Albab
    headline: Senior Software Engineer (AI | TypeScript | Backend/Fullstack)
    phone: "+971 50 123 4567"
    email: irshad@albab.com
    summary: Senior Software Engineer with 12+ years of experience in designing and architecting AI-native SaaS applications. Expertise in building high-concurrency systems using NestJS, Node.js, TypeScript, and AWS. Proven expertise in integrating LLM APIs (OpenAI, Anthropic) and developing performance-optimized data pipelines with ClickHouse.

  location:
    city: Dubai
    country: United Arab Emirates

  profiles:
    # - network: LinkedIn
    #   url: https://linkedin.com/in/irshadalbab
    #   username: irshadalbab
    - network: GitHub
      url: https://github.com/in/irshadalbab
      username: irshadalbab

  education:
    - institution: Global Institute of Technology
      degree: Bachelor
      area: Computer Science (Engineering)
      startDate: Apr 1, 2008
      endDate: March 31, 2012

  work:
    - name: Nexus SaaS Solutions
      url: https://www.nexussaas.io/
      startDate: 2022-05-01
      position: Senior Software Engineer
      summary: |
        - Architected a high-throughput AI orchestration layer using NestJS and OpenAI/Anthropic APIs, implementing robust prompt engineering and rate-limiting to handle 3M+ monthly inference calls.
        - Engineered a high-performance OLAP data strategy using ClickHouse, optimizing complex analytical queries on 100M+ records to achieve sub-second latency (80% improvement).
        - Developed a distributed worker system for real-time natural language processing (NLP), leveraging asynchronous message queues to handle spikes of 10k+ concurrent requests.
        - Designed and implemented scalable vector-based data pipelines to enhance LLM context retrieval and output accuracy across multi-tenant SaaS environments.

    - name: Velocity Apps (Acquired by AstroTech)
      url: https://velocityapps.com/
      startDate: 2021-04-01
      endDate: 2022-04-01
      position: Senior Software Engineer
      summary: |
        - Designed and scaled a distributed microservices architecture supporting 100k+ concurrent active sessions with 99.9% system availability.
        - Optimized mission-critical scheduling algorithms and caching layers (Redis), resulting in a 35% reduction in end-to-end API response latency.
        - Engineered a unified third-party integration framework that standardized heterogeneous data inputs, reducing partner onboarding time by 65%.

    - name: Horizon Technologies
      url: https://horizon-tech.example/
      startDate: 2017-08-01
      endDate: 2021-03-31
      position: Software Engineer / Tech Lead
      summary: |
        - Served as Technical Lead for cross-functional engineering teams, standardizing CI/CD pipelines and instituting TDD/BDD methodologies across multiple product lines.
        - Authored comprehensive technical specifications and system design documents for migrating monolithic applications to scalable cloud-native architectures.
        - Mentored a team of 5+ engineers, facilitating technical workshops on design patterns and code quality to improve overall development velocity.

    - name: Global Solutions Corp
      url: https://www.globalsolutions.com/
      startDate: 2016-10-01
      endDate: 2017-09-30
      position: Software Engineer
      summary: |
        - Developed high-security backend modules using ASP.NET and C#, implementing strict data encryption and RBAC (Role-Based Access Control) for enterprise clients.
        - Refactored legacy T-SQL procedures and optimized relational schemas, achieving a 20% improvement in database throughput and query execution plans.

    # - name: Tech Stream Systems
    #   url: https://www.techstream.com/
    #   startDate: 2013-04-01
    #   endDate: 2016-09-30
    #   position: Web Developer
    #   summary: |
    #     - Engineered automated ETL (Extract, Transform, Load) pipelines to process large-scale datasets, reducing manual data processing time by 100+ hours monthly.
    #     - Spearheaded the development of secure, transaction-heavy modules, ensuring 100% data integrity and zero-delay delivery for high-stakes projects.

  skills:
    - name: Languages & Frameworks
      level: Expert
      keywords:
        - TypeScript
        - JavaScript (ES6+)
        - C#
        - Node.js
        - NestJS
        - Next.js
        - Express.js
        - React
        - Angular
    - name: Databases
      level: Expert
      keywords:
        - PostgreSQL
        - ClickHouse
        - MySQL
        - MS SQL Server
        - Data Modeling
        - Performance Optimization
    - name: Cloud & DevOps
      level: Expert
      keywords:
        - AWS (Lambda, EC2, S3, SQS, RDS)
        - Docker
        - CI/CD Pipelines
    - name: AI & API Integrations
      level: Expert
      keywords:
        - OpenAI API
        - Anthropic Claude
        - REST/RPC API Design
        - Payment Integrations

  # awards:
  #   - title: Professional Excellence Award
  #     awarder: Tech Stream Systems
  #     summary: Awarded for achieving 100% client satisfaction and maintaining a consistent record of zero-delay delivery for high-stakes fintech projects.
`;
